module.exports = __webpack_public_path__ + "img/eye-closed.7fc8bc76.svg";